var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-wrapper"},[_c('div',{staticClass:"main-container"},[_c('app-main',{staticStyle:{"height":"100%"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }